var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClass,on:{"click":_vm.wave}},[(_vm.to)?_c('router-link',{staticClass:"navbar-brand",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c(_vm.tag,{tag:"component",staticClass:"navbar-brand",on:{"click":_vm.wave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04bf7ad3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/mdbvue/src/components/NavbarBrand.vue
// module id = null
// module chunks = 